import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSnowflake } from '@fortawesome/pro-regular-svg-icons';
import { useIsMutating } from '@tanstack/react-query';
import { CircularProgress } from '@nexelem/components';
import { freezeTaskMutationKey } from '../../../../../../queryHooks/productionPlanHooks';
import { useSimulationId } from '../../../GanttSimulation/hooks';
import { cn } from '@nexelem/utils';

type SimulationSnowflakeIconProps = {
  nodeId: number;
  frozen: boolean;
  className?: string;
};

export const SimulationSnowflakeIcon = ({ nodeId, frozen, className }: SimulationSnowflakeIconProps) => {
  const simulation = useSimulationId();
  const isMutationPending = useIsMutating({ mutationKey: freezeTaskMutationKey(simulation.id, nodeId) });

  if (!simulation.id) {
    return null;
  }
  if (isMutationPending) {
    return <CircularProgress className={className} size={15} />;
  }

  if (frozen) {
    return <FontAwesomeIcon className={cn('size-4 text-icon-focus', className)} icon={faSnowflake} />;
  }

  return null;
};
